var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLubbersLogoYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 14.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .a {\r\n        fill: #fbe920;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29,9c0,1.42-.58,2.13-1.72,2.13S25.54,10.46,25.54,9V4.91h-1.6V9c0,2.34,1.21,3.68,3.32,3.68S30.57,11.38,30.57,9V4.91H29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M56.09,10.43a2.23,2.23,0,0,1-1.71.73,2,2,0,0,1-2.12-1.73l5.93,0V9.34a5.27,5.27,0,0,0,0-.68A3.83,3.83,0,0,0,54.35,4.9a3.75,3.75,0,0,0-2.71,1.18,4,4,0,0,0-1.08,2.77,3.86,3.86,0,0,0,2.53,3.65,4.09,4.09,0,0,0,1.34.22,3.84,3.84,0,0,0,3.46-2.21l.06-.12H56.11Zm.43-2.36-4.25,0A2.22,2.22,0,0,1,54.4,6.46a2,2,0,0,1,.72.13,2.29,2.29,0,0,1,1.4,1.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M67.39,8.09c-.82-.18-1.53-.34-1.53-.91s.49-.83,1.18-.83,1.27.3,1.27.86v.08h1.53V7.21c0-1.37-1.12-2.3-2.77-2.3s-2.8.91-2.8,2.17c0,1.69,1.43,2,2.58,2.26.87.19,1.63.36,1.63,1s-.51.91-1.34.91-1.46-.4-1.46-1v-.08H64.15v.08c0,1.16.93,2.42,3,2.42a3.3,3.3,0,0,0,2.38-.8,2,2,0,0,0,.58-1.53c0-1.73-1.5-2.05-2.68-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.36,4.91a3.9,3.9,0,0,0-2.3.75v-4h-1.6V8.43A3.93,3.93,0,0,0,33,10.78h0l0,.05,0,0a3.76,3.76,0,0,0,.83.95h0l.13.1.11.08,0,0a3.91,3.91,0,0,0,4.41-6.45,4,4,0,0,0-2.21-.68m0,6.16a2.26,2.26,0,1,1,2.26-2.25,2.25,2.25,0,0,1-2.26,2.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.46,4.91a3.88,3.88,0,0,0-2.3.75v-4H41.55V8.43a4,4,0,0,0,.53,2.35h0l0,.05,0,0a3.93,3.93,0,0,0,.82.95h0l.12.1.11.08,0,0a3.9,3.9,0,0,0,4.4-6.45,3.94,3.94,0,0,0-2.2-.68m0,6.16a2.26,2.26,0,1,1,2.25-2.25,2.26,2.26,0,0,1-2.25,2.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.86,12.62a2,2,0,0,1-2.18-2.19V1.64h1.6v8.54c0,.61.22.93.86.93h.71v1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M63.15,4.81V6.32h-.7c-.65,0-.87.32-.87.93v5.37H60V7a2,2,0,0,1,2.17-2.19Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.37,1l1.38,2.39L13.37,5.81H10.61L9.23,3.42,10.61,1h2.76m.31-.54H10.29L8.6,3.42l1.69,2.94h3.39l1.7-2.94L13.68.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.46,1.44,7,5.81H1.93L4.46,1.44m0-1.09L1,6.36H7.93L4.46.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.46,8.23A2.56,2.56,0,1,1,1.9,10.79,2.56,2.56,0,0,1,4.46,8.23m0-.55a3.11,3.11,0,1,0,3.1,3.11,3.11,3.11,0,0,0-3.1-3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.13,8.39l1.75,1.74L12,13,9.1,10.13l1.75-1.74.75.76.39.38.38-.38.76-.76m0-.77L12,8.76,10.85,7.62,8.33,10.13,12,13.79l3.66-3.66L13.13,7.62Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLubbersLogoYellow);
export default __webpack_public_path__ + "static/media/lubbers-logo-yellow.fc79302ff80b0fe687f09b584c4b47a9.svg";
export { ForwardRef as ReactComponent };